// import React from 'react';
// import '../styles/CloudJourney.css';

// import curve from '../../../../assets/solutions/cloudadoption/curve.png';
// import discovery from '../../../../assets/solutions/cloudadoption/discovery.png';
// import cloudstrategy from '../../../../assets/solutions/cloudadoption/cloudstrategy.png';
// import securedata from '../../../../assets/solutions/cloudadoption/securedata.png';
// import environment from '../../../../assets/solutions/cloudadoption/environment.png';
// import testing from '../../../../assets/solutions/cloudadoption/testing.png';
// import costoptimization from '../../../../assets/solutions/cloudadoption/costoptimization.png';

// const steps = [
//   {
//     icon: discovery,
//     title: 'Discovery & Assessment',
//     description: 'Start by taking a close look at your current systems. Identify what applications and workloads you have, how they interact, and how they’re performing today. This helps you understand what needs to move and what might need special attention.',
//   },
//   {
//     icon: cloudstrategy,
//     title: 'Cloud Strategy & Architecture',
//     description: 'Synectiks clear goals for your migration, whether it’s cost savings, better performance, or something else. Then, design a cloud architecture that fits those goals, whether you’re moving everything to the cloud or keeping some systems on-premises.',
//   },
//   {
//     icon: securedata,
//     title: 'Secure Data & Application Migration',
//     description: 'Synectiks takes full control in moving your data and applications to the cloud using reliable migration tools such as AWS Migration Hub or Azure Migrate. We help you transfer everything securely and efficiently, minimizing downtime.',
//   },
//   {
//     icon: environment,
//     title: 'Environment Provisioning',
//     description: 'With the help of experienced Cloud Architects, Synectiks helps you by setting up the necessary infrastructure for building servers, networks and other essential resources.',
//   },
//   {
//     icon: testing,
//     title: 'Testing & Validation',
//     description: 'Once your systems are in the cloud, Synectiks runs thorough tests to make sure everything works as expected. We ensure to check that applications function correctly, integrate smoothly, and meet your security standards.',
//   },
//   {
//     icon: costoptimization,
//     title: 'Cost & Performance Optimization',
//     description: 'After migration, we will monitor your cloud environment closely. Synectiks will help you at every step.',
//   },
// ];

// const CloudJourney = () => {
//   return (
//     <section className="cloud-journey">
//       <div className="journey-container">
//         <h2 className="journey-title">Moving to<br />cloud journey</h2>
//         <div className="journey-timeline">
//           <div className="timeline-path" style={{ backgroundImage: `url(${curve})` }} />
//           {steps.map((step, index) => (
//             <div className="journey-step" key={index}>
//               <div className="step-node" />
//               <div className="step-icon">
//                 <img src={step.icon} alt={step.title} />
//               </div>
//               <div className="step-content">
//                 <h3>{step.title}</h3>
//                 <p>{step.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CloudJourney;

import React from 'react';
import '../styles/CloudJourney.css';

import desktopCurve from "../../../../assets/solutions/cloudadoption/flowchart.svg";
import mobileCurve from "../../../../assets/solutions/cloudadoption/flowchart-mobile.svg";

const CloudJourney = () => {
  return (
    <section className="cloud-journey">
      <div className="journey-container">
        <div className="left-column">
          <h2 className="journey-title">
            Moving to
            Cloud Journey
          </h2>
        </div>
        <div className="right-column">
          {/* Replace the img tag with this picture element */}
          <picture>
            <source media="(max-width: 768px)" srcSet={mobileCurve} />
            <img
              src={desktopCurve}
              alt="Cloud Journey Curve"
              className="journey-image"
            />
          </picture>
        </div>
      </div>
    </section>
  );
};

export default CloudJourney;
